import { createAction, props } from "@ngrx/store";

export const showLoadingAction = createAction(
  "[Loading] show Loading",
  props<{}>()
);

export const closeLoadingAction = createAction(
  "[Loading] close Loading",
  props<{}>()
);
